<template>
  <div v-if="question.id" class="discussion">
    <div v-if="question.text" class="discussion__text">{{ question.text }}</div>
    <div v-if="question.datetimeCreated" class="discussion__small-description">
      Asked by {{ question.authorRef.username }} on
      {{ question.datetimeCreated | momentDateTimeShort }}
    </div>

    <div v-for="answer in question.answersRef" :key="answer.id" class="answers">
      <div>
        <font-awesome-icon icon="reply" size="1x" class="reply-icon" />
      </div>
      <div class="answers__content">
        <div class="discussion__text">{{ answer.text }}</div>
        <div>
          <div class="discussion__small-description">
            Answered by {{ answer.authorRef.username }}
          </div>
          <div class="discussion__small-description">
            {{ answer.datetimeCreated | momentDateTime }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiscussionCard',
  props: {
    question: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/buttons';
@import '../styles/layout';

.discussion {
  width: 100%;
  padding: 1rem 1rem 1.5rem 1rem;

  &__small-description {
    text-align: left;
    font-size: 12px;
    line-height: normal;
    color: $gray;
    margin-bottom: 6px;
  }

  &__text {
    text-align: left;
    font-size: 14px;
    line-height: 1.1rem;
    padding: 2px 20px 8px 0;
  }
}

.answers {
  display: flex;
  margin-top: 16px;
  margin-left: 6px;

  &__content {
    margin-left: 6px;
  }
}

.reply-icon {
  transform: rotate(180deg);
}
</style>
